import { Box, Center, Input, Text } from '@chakra-ui/react'
import { useRef } from 'react'
import LazyAvatar from '../lazy/LazyAvatar'
import { LazyLoadedImage } from '../lazy/LazyLoadedImage'
import { useCamera } from '../modals/CommunityImageSelectModalModal'
import { Capacitor } from '@capacitor/core'

interface ImageSelectProps {
  isImage?: boolean
  displayFullImage?: boolean
  image: File | null
  onChange: (image: File | null) => void
}

const ImageSelect = (props: ImageSelectProps) => {
  const buttonRef = useRef<HTMLInputElement | null>(null)

  const handleClick = () => {
    if (props.image) {
      props.onChange(null)
    } else {
      if (buttonRef.current) {
        buttonRef.current.click()
      }
    }
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0]
    if (selectedFile) {
      props.onChange(selectedFile)
    }
    if (buttonRef.current) {
      buttonRef.current.value = ''
    }
  }

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    const selectedFile = e.dataTransfer.files?.[0]

    if (selectedFile) {
      props.onChange(selectedFile)
    }

    if (buttonRef.current) {
      buttonRef.current.value = ''
    }
  }

  const hideElements = props.image && props.displayFullImage

  return (
    <>
      <Box
        onDragOver={(e) => {
          e.preventDefault()
        }}
        onDrop={(e) => {
          e.preventDefault()
          handleDrop(e)
        }}
      >
        <Input
          display="none"
          cursor="pointer"
          type="file"
          accept=".png,.jpeg,.jpg,.gif"
          minW="48px"
          h="48px"
          position="absolute"
          onChange={(e) => handleFileChange(e)}
          ref={buttonRef}
        />
        <Center
          cursor="pointer"
          onClick={() =>
            Capacitor.isNativePlatform()
              ? useCamera().then((result) => props.onChange(result.file))
              : handleClick()
          }
          h="132px"
          borderRadius="4px"
          border="1px solid #DCE2EA"
          borderStyle="dashed"
          background="linear-gradient(0deg, #F7F8FA, #F7F8FA)"
          // bgImage={props.image && props.displayFullImage ? URL.createObjectURL(props.image) : undefined}
          bgPos="top center"
          bgSize="cover"
          position="relative"
        >
          <LazyLoadedImage
            w="100%"
            h="100%"
            src={props.image && props.displayFullImage ? URL.createObjectURL(props.image) : undefined}
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            m="auto"
          />

          <Box>
            {props.image && !props.displayFullImage ? (
              <Center>
                <LazyAvatar width={52} height={52} m="10px 0" src={URL.createObjectURL(props.image)} />
              </Center>
            ) : hideElements ? (
              <></>
            ) : (
              // <LazyLoadedImage
              //     w='52px' h='52px'
              //     src={URL.createObjectURL(props.image)}
              //     m='10px auto'
              // />
              <Box
                m="10px auto"
                bgImage={props.isImage ? '/components/photo.svg' : '/components/profile.svg'}
                w="52px"
                h="52px"
              />
            )}
            {hideElements ? (
              <></>
            ) : (
              <Text variant="subtle" textAlign="center" fontWeight="400">
                <span
                  style={{
                    color: '#171C22',
                    fontWeight: '500',
                  }}
                >
                  Click
                </span>{' '}
                to upload a file
              </Text>
            )}
          </Box>
        </Center>
      </Box>
    </>
  )
}

export default ImageSelect
